import { MERCHANT } from "constants/action-types";
import { SchemaTypes, ISchema } from "constants/merchant";
import { FluxStandardAction as Action } from "flux-standard-action";

export type FetchSchemaAction = Action<
    {
        merchantId: string;
        schemaType: SchemaTypes;
    },
    {}
>;

export const fetchSchema = (merchantId: string, schemaType: SchemaTypes): FetchSchemaAction => ({
    meta: {},
    payload: { merchantId, schemaType },
    type: MERCHANT.SCHEMA.FETCH,
});

export type FetchedSchemaAction = Action<ISchema | Error, {}>;

export const fetchedSchema = (payload: ISchema | Error): FetchedSchemaAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.SCHEMA.FETCHED,
});
